import { VoucherStatus, NormalizedVoucher } from '@esportal/portal-service';
import { COLOR_TOKEN } from '../../../helpers/color-tokens';

export class VouchersHelper {
	public static getValidityMessage(
		voucherStatus: VoucherStatus,
		vouchersExpirationDate: number | string | Date | null,
		vouchersEnjoyed: string | number | Date | null | undefined,
	): string {
		enum VoucherStatusMessage {
			'EXPIRED' = 'Vencido',
			'ENJOYED' = 'Disfrutado el #DATE_ENJOYED',
			'TO_ENJOY' = 'Válido hasta el #DATE_EXPIRATION',
			'NO_EXPIRATION' = 'Disponible',
			'TO_ENJOY_SOON' = 'Válido hasta el #DATE_EXPIRATION',
		}

		const messageToUse: string = (VoucherStatusMessage as any)[voucherStatus as string];

		return messageToUse
			.replace('#DATE_ENJOYED', vouchersEnjoyed ? this._getDataValidityString(vouchersEnjoyed as number | string) : '')
			.replace(
				'#DATE_EXPIRATION',
				vouchersExpirationDate ? this._getDataValidityString(vouchersExpirationDate as number | string) : '',
			);
	}

	public static getVoucherStatusColor(voucherStatus: VoucherStatus): string {
		const VoucherStatusColor: Record<string, string> = {
			'EXPIRED': COLOR_TOKEN.signal.error,
			'ENJOYED': COLOR_TOKEN.signal.error,
			'TO_ENJOY': COLOR_TOKEN.signal.success,
			'NO_EXPIRATION': COLOR_TOKEN.signal.success,
			'TO_ENJOY_SOON': COLOR_TOKEN.signal.promo,
		};

		const colorToUse: string = VoucherStatusColor[voucherStatus as string];

		return colorToUse;
	}

	public static buildValidityMessage(voucher: NormalizedVoucher): string {
		const vouchersValidityDate: Date = new Date((voucher.validityDate as number) * 1000);

		let leftDays: number = 0;

		let vouchersExpirationDate: Date | null = null;
		let vouchersExpirationString: string = '';

		if (voucher.expirationDate) {
			vouchersExpirationDate = new Date((voucher.expirationDate as number) * 1000);
			leftDays = (vouchersExpirationDate.getTime() - vouchersValidityDate.getTime()) / (1000 * 3600 * 24);
			vouchersExpirationString = `${vouchersExpirationDate.getDate()}/${
				vouchersExpirationDate.getMonth() + 1
			}/${vouchersExpirationDate.getFullYear()}`;
		}

		const vouchersValidityString: string = `${vouchersValidityDate.getDate()}/${
			vouchersValidityDate.getMonth() + 1
		}/${vouchersValidityDate.getFullYear()}`;

		return vouchersExpirationDate == null
			? `La ventaja no tiene fecha de expiración`
			: `La ventaja es válida hasta ${leftDays} días después de ser emitida. Disponible del ${vouchersValidityString} hasta el ${vouchersExpirationString}
    `;
	}

	private static _getDataValidityString(dateTimestamp: number | string): string {
		const date: Date = typeof dateTimestamp === 'string' ? new Date(dateTimestamp) : new Date(dateTimestamp * 1000);
		return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
	}
}
